<!-- Full-screen blocking version gate. z-index sits above CDK overlays/dialogs. -->
@if (gate) {
  <div class="fixed inset-0 flex items-center justify-center bg-black/70 p-4"
     style="z-index: 2147483000">
    <div class="w-full max-w-lg rounded-2xl bg-card shadow-2xl p-8 text-center">
        <div class="flex items-center justify-center w-14 h-14 mx-auto rounded-full bg-amber-100 text-amber-600 dark:bg-amber-500 dark:text-amber-50">
            <mat-icon class="icon-size-7 text-current"
                      [svgIcon]="'heroicons_outline:exclamation-triangle'"></mat-icon>
        </div>

        <h1 class="mt-5 text-2xl font-semibold">{{ gate.title }}</h1>

        <div class="mt-3 text-secondary leading-relaxed text-left"
             [innerHTML]="gate.body | markdown"></div>

        <button mat-flat-button
                [color]="'primary'"
                class="mt-7"
                (click)="reload()">
            <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
            <span class="ml-2">Log out &amp; sign in</span>
        </button>
    </div>
  </div>
}
